import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactForm, ContactFormData } from '../../components/ContactForm/ContactForm';
import './ContactPage.scss';
import whiteCheckmark from '../../assets/icons/white-checkmark.svg';
import { mockUserData } from './mockData';
import { useAuth } from '../../contexts/AuthContext';

export const AuthenticatedContactPage: React.FC = () => {
  const { t } = useTranslation('contact');
  const { user } = useAuth();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (data: ContactFormData) => {
    try {
      // Import the contact service
      const { contactService } = await import('../../services/contact.service');
      
      try {
        // Add remoteObjectId and membershipNumber to the form data
        const formDataWithRemoteId = {
          ...data,
          remoteObjectId: user?.remoteObjectId,
          membershipNumber: user?.accountInformations?.membershipNumber
        };
        
        // Submit the form data to Salesforce Web-to-Case
        const response = await contactService.submitWebToCase(formDataWithRemoteId);
        if (response.status === 200 || response.status === 201) {
          setSubmitted(true);
        }
      } catch (error: any) {
        // Check if this is the expected CORS error (which actually means success)
        if (error.code === 'ERR_NETWORK' && error.config?.url?.includes('salesforce.com')) {
          setSubmitted(true);
        } else {
          console.error('Error submitting contact form:', error);
        }
      }
    } catch (error) {
      console.error('Error importing contact service:', error);
    }
  };

  if (submitted) {
    return (
      <div className="contact-page">
        <div className="contact-page__success">
          <div className="contact-page__success-icon">
            <img src={whiteCheckmark} alt="Success" />
          </div>
          <div className="contact-page__success-content">
            <h1>{t('success.title')}</h1>
            <p>{t('success.message')}</p>
            <button 
              className="contact-page__button"
              onClick={() => setSubmitted(false)}
            >
              {t('success.newRequest')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <ContactForm 
        isAuthenticated={true} 
        onSubmit={handleSubmit}
        defaultValues={{
          firstName: user?.firstName || mockUserData.firstName,
          lastName: user?.lastName || mockUserData.lastName,
          email: user?.email || mockUserData.email
        }}
      />
    </div>
  );
};
